import React from "react";
import {Box} from "@unibuddy/patron";
import {useTranslation} from "@unibuddy/intl";
import {useMutation} from "@apollo/client";

import resetPasswordMutation from "shared/PasswordReset/mutations/resetPasswordMutation";

import {AuthPageContainer} from "../../../../widgets/modules/RegisterNew/components/AuthPageContainer";
import {ResetPasswordHeading} from "./ResetPasswordHeading";
import {ResetPasswordForm} from "./ResetPasswordForm";
import {PageTitle} from "../../../../components/PageTitle/PageTitle";
import {IntlNamespaces} from "../../../../translations/types";
import {INTL_RESET_PASSWORD} from "../../../../translations/passwordReset";

type ResetPasswordProps = {
    token: string;
    userId: string;
    onComplete: (redirectUrl: string) => void;
};

export function ResetPasswordPage({token, userId, onComplete}: ResetPasswordProps) {
    const {t} = useTranslation(IntlNamespaces.PASSWORD_RESET);
    const [resetPassword] = useMutation(resetPasswordMutation);

    const handleSubmit = async (
        password: string,
        setFieldError: (field: string, message: string | undefined) => void,
    ): Promise<void> => {
        try {
            const {data} = await resetPassword({
                variables: {
                    password,
                    token,
                    userId,
                },
            });

            if (data?.resetPasswordV2?.error) {
                setFieldError("password", data.resetPasswordV2.error as string);
            } else {
                const redirectUrl: string = data?.resetPasswordV2?.redirectUrl;
                onComplete(redirectUrl);
            }
        } catch (e) {
            console.error(e);
            throw e;
        }
    };

    return (
        <Box
            w="100%"
            minH="100vh"
            h="100%"
            display="flex"
            justifyContent="center"
            alignItems="center"
        >
            <Box maxW="600px" w="100%">
                <AuthPageContainer>
                    <PageTitle
                        title={t(INTL_RESET_PASSWORD.key, INTL_RESET_PASSWORD.defaultValue)}
                    />
                    <ResetPasswordHeading />
                    <ResetPasswordForm handleSubmit={handleSubmit} />
                </AuthPageContainer>
            </Box>
        </Box>
    );
}
